import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaGlobe } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import "./Footer.css";
import logoCN from "./logo.svg";
import { useNavigate } from "react-router-dom"; // Importa useNavigate

const Footer = () => {
    const navigate = useNavigate(); // Inicializa el hook

  return (
    <footer>
      <div className="contacto-footer">
        <div className="footer-header-container">
          <div className="logo-title-wrapper">
            <img src={logoCN} alt="Logo CNgroup" className="footer-logo-img" />
          </div>
        </div>
        <div className="footer-grid">
          {/* Bloques de frases con su línea separadora */}
          <div className="footer-phrase-block phrase-1">
            <p>Energía al alcance de todos. Limpia, asequible y accesible.</p>
            <hr className="phrase-separator" />
          </div>
          <div className="footer-phrase-block phrase-2">
            <p>Compromiso con el medio ambiente y sostenibilidad energética.</p>
            <hr className="phrase-separator" />
          </div>
          <div className="footer-phrase-block phrase-3">
            <p>Convertimos la energía en realidad con nuestros trabajos.</p>
            <hr className="phrase-separator" />
          </div>
          <div className="footer-phrase-block phrase-4">
            <p>Ofrecemos soluciones energéticas inteligentes y asequibles.</p>
            <hr className="phrase-separator" />
          </div>

          {/* Bloque de Contacto */}
        <div className="footer-contact-block">
        <p><strong>Contáctenos</strong></p>
        <button 
          className="footer-contact-button"
          onClick={() => navigate('/contacto')} // Navegación programática
        >
          Contacto
        </button>
      </div>

          {/* Bloque de Más información */}
          <div className="footer-info-block">
            <p><strong>Más información</strong></p>
            <p>
              Correo: <a href="mailto:info@cnq.es" className="footer-link">info@cnq.es</a>
            </p>
            <p>
              Teléfono: <a href="tel:+34958168199" className="footer-link">958-168-199</a>
            </p>
          </div>

          {/* Bloque de Redes sociales */}
          <div className="footer-social-block">
            <p><strong>Redes sociales</strong></p>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/1EcevoXVWt/" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                <FaFacebookF />
              </a>
              <a href="https://x.com/tuperfil" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                <RiTwitterXLine />
              </a>
              <a href="https://www.instagram.com/tuperfil" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com/company/cn-stigendes-l-u/" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Bloque de Ubicación */}
          <div className="footer-location-block">
            <p><strong>Ubicación</strong></p>
            <a
              href="https://www.google.com/maps/place/Príncipe+de+Vergara+132,+28002+Madrid,+España"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-location-link"
            >
              <div className="footer-location">
                <FaGlobe className="globe-icon" />
                <span>Príncipe de Vergara 13228002, Madrid, España</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-copyright-bar">
        <p>&#169; 2025 Copyright: <a href="mailto:info@cnq.es" className="footer-link">info@cnq.es</a></p>
      </div>
    </footer>
  );
};

export default Footer;